let routes = [
    {
    path: '/',
    name: '/',
    // 主页
      component: () => import ('@/views/PageIndex/Home'),
       //component: () => import ('@/views/Record/ServiceRecord/RecordList/index'),//服务记录
     // component: () => import ('@/views/InterfereRecord/Interfere/index'), //干预记录


    meta: {
        title: '主页',
        showTab:true
    }
},
  {
    path:'/chat',
    component:() => import('@/views/chat/chat'),
    meta:{
      title: '消息',
      showTab:true
    }
  },
  {
    path:'/me',
    component:() => import('@/views/personal/homePage/homePage.vue'),
    meta:{
      title: '我的',
      showTab:true
    }
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routerPage/TabBar.js